export default "__VITE_ASSET__f9d30895__"